import { Link } from "@tanstack/react-router";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";

import { Button, Row } from "@kuzco/web/ui";

import { EmptyStateLayout } from "./EmptyStateLayout";

type NotFoundViewProps = {
  /**
   * What renders in the action row. If omitted, a default action set
   * (Go back + Home) is used.
   */
  actions?: React.ReactNode;
  /**
   * If true, omits the top-left Inference logo header. Use this when rendering
   * inside the dashboard shell (which already has its own logo/chrome).
   */
  hideHeader?: boolean;
  /** Override the default headline. */
  title?: string;
  /** Override the default body copy. */
  description?: React.ReactNode;
};

function DefaultActions() {
  return (
    <Row className="gap-4">
      <Button onClick={() => window.history.back()} size="lg" variant="outline">
        <ArrowLeftIcon className="mr-2" size={18} />
        Go back
      </Button>
      <Link to="/">
        <Button size="lg" variant="default">
          Home
          <ArrowRightIcon className="ml-2" size={18} />
        </Button>
      </Link>
    </Row>
  );
}

export function NotFoundView({
  actions,
  hideHeader = false,
  title = "This page doesn't exist",
  description = "You may have followed an outdated link, or the page has been moved.",
}: NotFoundViewProps) {
  return (
    <EmptyStateLayout
      imageSrc="/lost-bot.png"
      title={title}
      description={description}
      actions={actions ?? <DefaultActions />}
      hideHeader={hideHeader}
    />
  );
}
